import React from 'react';
import { connect } from 'react-redux';
import { DBTextAreaObjective, DBRadioButton, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class SpeechLanguage extends React.Component {

    render() {
        return (
            <div>
                
                <div className={styles.row}>
                    {this.props.flagged && <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} flagText='Speech Language' />}
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSLANGUAGESTATUS'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                            
                            
                             <div className={styles.label} />

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Delayed'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSLANGUAGESTATUS'
                             entityKeyValue={this.props.osno}
                             label='Delayed'
                             className={styles.radio}
                            />   

                            <div className={styles.label} />
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSLANGUAGESTATUS'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />  
 
                    </div>
                    <div className={styles.row}>
                        <b>Comments</b>
                    </div>

                <div className={styles.row}>
                    <DBTextAreaObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        field='OSLANGUAGECOMMENTS'
                        className={styles.textarea}
                    />

                </div>
               
            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let osno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPEECH)
    .find(key => (state.entities.notes.PTOBJECTIVESPEECH[key].OSEVNO === pk && noteType === 1)
        || (state.entities.notes.PTOBJECTIVESPEECH[key].OSNTNO === pk && noteType !== 1)));
        
    return {
        noteId: noteId,
        osno: osno,
        flagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSLANGUAGESTATUS !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSLANGUAGESTATUS !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSLANGUAGESTATUS !== 'WNL')
        ? true : false
    };
}

const connectedSpeechLanguage = connect(mapStateToProps)(SpeechLanguage);
export { connectedSpeechLanguage as SpeechLanguage };


